import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    presidentImage: {
        objectFit: "contain",
        alignSelf: "center",
        height: 275,
        width: 200
    },
    headerTitleContainer: {
        position: "absolute",
        alignItems: "center",
        right: 0,
        left: 0
    },
    loadingContainer: {
        justifyContent: "center",
        alignItems: "center"
    },
    headerContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    backButton: {
        alignSelf: "flex-start"
    },
    contentContainer: {
        alignItems: "center"
    },
    headerTitle: {
        textAlign: "center"
    },
    container: {
        paddingTop: 0
    },
    flex1: {
        flex: 1
    }
});
export default stylesheet;
